/**
 * Angular imports.
 */
import { Component, OnInit, Output, EventEmitter, OnDestroy, Input, OnChanges, ElementRef, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
/**
 * Rxjs imports.
 */
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/**
 * Constant imports.
 */
import { MEMBERS_LIST_TYPE, COMMUNITY_USER_TYPE, COMMUNITY_MEMBERS_ACTION, NUMBERS, SCREEN_NAME, PRODUCT_TYPE_CONSTANT_NAME, CTA_TYPE, ACTION_TYPE, ACTION_ON } from '../../constants/app.constants';

/**
 * Service imports.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { GetService } from '../../dataservices/get.service';
import { CreateCommunityService } from '../create-community/create-community.service';
/**
 * Interface import.
 */
import { CommunityMember } from '../../onboarding/interface/global.model';
import { CommunityMembersResponse } from '../../onboarding/interface/apiResponse.model';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { ENETDOWN } from 'constants';
/**
 * community-member-Listing.
 */
@Component({
  selector: 'app-community-member-listing',
  templateUrl: './community-member-listing.component.html',
  styleUrls: ['./community-member-listing.component.scss']
})
export class CommunityMemberListingComponent implements OnInit, OnDestroy, OnChanges {

  /**
   * Total checkbox selected limit.
   * Member list for list of existing members
   * Suggestion list must have id, name property.
   * selected list must have id, name property.
   * Title of the selected list.
   * No data found msg in case of search.
   * Max limit exceed error msg.
   * Search filter placeholder.
   * Title for the list.
   * Api in process flag for loading and no data available.
   * In view all page or not.
   */

  @Input() suggestionList = [];
  @Input() memberList = [];
  @Input() selectedList = [];
  @Input() selectedTitle = '';
  @Input() noDataFoundLabel = '';
  @Input() maxLimitErrorLabel = '';
  @Input() filterPlaceholder = '';
  @Input() title = '';
  @Input() apiInProcess = false;
  @Input() isViewAllEnable = false;
  @Input() loggedInUserCustomId = '';
  @Input() communityCreatedBy = {};
  @Input() showExistingUserFlag = false;
  @Input() communityEntityCode;
  /**
   * Selected member those are removed.
   */
  @Input() membersSelectedRemoved?;
  /**
   * State of the flow
   */
  @Input() clicked: number;
  /**
   * Review state for flow
   */
  @Input() reviewState: number;
  /**
   * Screen name
   */
  @Input() callingFrom: string;

  public buttonType = 'remove';

  /**
   * Remove the subscription.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Store searched keyword.
   * Max limit error msg to show in the DOM.
   * Filter for the search.
   * Config for perfectScroll.
   * Show Forward Arrow In case of Community
   * Show Existing User Flag for Mobile Web
   */
  public keyword = '';
  public maxLimitErrorMsg = '';
  public search: Subject<string> = new Subject();
  public config = {};
  public memberListType = MEMBERS_LIST_TYPE;
  public showForwardArrow = true;
  public showExistingUsersFlag = false;

  private internalSource = this.fcs.currentScreename;
  /**
   * Community member type constant.
   */
  public memberType = COMMUNITY_USER_TYPE;
  /**
   * Constant number
   */
  public numbers = NUMBERS;
  /**
   * max pop up switch
   */
  public showMaxPopUp = false;
  /**
   * Emit search keyword outside.
   * emit back to suggestions outside.
   * emit view all flag outside.
   * emit on scroll event outside.
   */
  @Output() emitSearchKey: EventEmitter<string> = new EventEmitter();
  @Output() emitBackToSuggestions: EventEmitter<string> = new EventEmitter();
  @Output() emitViewAll: EventEmitter<string> = new EventEmitter();
  @Output() emitOnScroll: EventEmitter<string> = new EventEmitter();
  @Output() emitExistingUserFlag: EventEmitter<boolean> = new EventEmitter();

  @Output() emitCheckUncheckUser: EventEmitter<boolean> = new EventEmitter();
  @Output() emitOnMemberScroll: EventEmitter<string> = new EventEmitter();
  @Output() emitMembersSelected: EventEmitter<CommunityMember> = new EventEmitter();
  @Output() emitMembersRemoved: EventEmitter<CommunityMember> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitSelectedList: EventEmitter<any> = new EventEmitter();

  public showMemberModal = false;
  /**
   * Offset for existing member list.
   */
  public existingMembersOffset = NUMBERS.ONE;

  /**
   * Existing members modal.
   */
  public existingmembersLoader = false;
  /**
   * Community id.
   */
  @Input() communityId: string;
  /**
   * Switch for button
   */
  public showAddagain = NUMBERS.ZERO;
  /**
   * Defining offset
   */
  public offset = NUMBERS.ONE;

  /**
   * public starttime
   */
  public startTime: number;

  /**
   * Constructor
   */

  constructor(
    public mls: NewLanguageService,
    private getApiAervice: GetService,
    public fcs: FunCollectionService,
    private route: ActivatedRoute,
    public createCommunityService: CreateCommunityService,
    private analyticSdk: Analytics) {
  }

  /**
   * Call Trigger search.
   */
  ngOnInit(): void {
    this.triggerSearch();
    this.communityId = this.route.snapshot.params['communityId'];
  }

  /**
   * Trigger the search with the debounce.
   */
  triggerSearch(): void {
    this.subscriptions.add(this.search.pipe(
      debounceTime(300)
    ).subscribe(key => {
      this.keyword = key;
      this.emitSearchKey.emit(this.keyword);
      this.scrollToTop();
    }));
  }

  /**
   * Back To suggestion and connection
   */
  backToSuggestion(): void {
    this.emitBackToSuggestions.emit();
  }

  /**
   * Search in the list.
   */
  searchInTheList(key: string): void {
    this.search.next(key);
  }

  /**
   * Remover connection search
   */
  resetSearchBox(): void {
    if(document.querySelector<HTMLInputElement>('#conSearch')) {
      document.querySelector<HTMLInputElement>('#conSearch').value = '';
    }
    this.keyword = '';
    this.emitSearchKey.emit(this.keyword);
    this.scrollToTop();
    this.createCommunityService.memberList = [];
  }

  /**
   * Scroll to top when list gets empty/small.
   */
  scrollToTop(): void {
    const myDiv = document.getElementById('containerDiv');
    const addDiv = document.getElementById('addMemDiv');
    if (myDiv || addDiv) {
      myDiv.scrollTop = NUMBERS.ZERO;
    }
  }

  /**
   * Emit the view All key.
   */
  viewAll(key: string): void {
    this.emitViewAll.emit(key);
    this.scrollToTop();
  }


  /**
   * add the selected items in selection array.
   */
  add(event, select: CommunityMember): boolean {
    this.createCommunityService.removeState = NUMBERS.ZERO;
    this.resetErrorMsg();
    if (event.target.checked === true) {
      if (this.selectedList.length >= NUMBERS.FIVE_HUNDRED) {
        this.showMaxPopUp = true;
        return false;
      }
      this.selectedList.push(select);
      select['action'] = COMMUNITY_MEMBERS_ACTION.ADD;
      this.emitMembersSelected.emit(select);
      this.emitCheckUncheckUser.emit(true);
    } else {
      const index = this.selectedList.findIndex((item) => {
        return item.custom_id === event.target.value;
      });
      if (index != NUMBERS.MINUS_ONE) {
        this.selectedList.splice(index, NUMBERS.ONE);
      }
      this.emitCheckUncheckUser.emit(false);
      select['action'] = COMMUNITY_MEMBERS_ACTION.REMOVE;
      this.emitMembersSelected.emit(select);
    }
    this.emitSelectedList.emit(this.selectedList);
  }
  /**
   * Remove the selected items in selection array.
   */
  remove(event, select: CommunityMember): boolean {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityEntityCode ?? '0', SCREEN_NAME.COMMUNITY_REMOVE_MEMBER,CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REMOVE_MEMBER, null);
    this.createCommunityService.removeState = NUMBERS.ONE;
    this.resetErrorMsg();
    if (event.target.checked === false) {
      if (this.selectedList.length >= NUMBERS.FIVE_HUNDRED) {
        this.showMaxPopUp = true;
        return false;
      }
      this.selectedList.push(select);
      select['action'] = COMMUNITY_MEMBERS_ACTION.REMOVE;
      this.emitMembersRemoved.emit(select);
      this.emitCheckUncheckUser.emit(false);
    } else {
      const index = this.selectedList.findIndex((item) => {
        return item.custom_id === event.target.value;
      });
      if (index != NUMBERS.MINUS_ONE) {
        this.selectedList.splice(index, NUMBERS.ONE);
      }
      this.emitCheckUncheckUser.emit(true);
      select['action'] = COMMUNITY_MEMBERS_ACTION.ADD;
      this.emitMembersRemoved.emit(select);
    }
    this.emitSelectedList.emit(this.selectedList);
  }

  /**
   * check Value for add flow
   */
  checkVal(select: CommunityMember): boolean {
    const selected = this.selectedList.filter(item => item.custom_id == select.custom_id);
    return (selected.length > NUMBERS.ZERO);
  }

  /**
   * onScroll
   */
  onScroll(): void {
    this.emitOnScroll.emit();
  }

  /**
   * onScroll
   */
  onMemberScroll(): void {
    this.emitOnMemberScroll.emit();
  }

  /**
   * reset Error Msg
   */
  resetErrorMsg(): void {
    this.maxLimitErrorMsg = '';
  }

  /**
   * Show Existing Users
   */
  showExistingUsers(): void {
    this.showExistingUsersFlag = true;
    this.emitExistingUserFlag.emit(true);
  }
  /**
   * 
   * @param currentValue 
   * @param previousValue 
   * @param reviewState 
   * handle member list steps
   */
  handleMemberListChange(previousValue, currentValue, reviewState) {
    // Handling previousValue
    let entryData: ENTRY = {
      entity_type: '',
      entity_code: this.communityEntityCode ?? 0,
      source: '',
      current_screen_name: '',
      start_time: 0
    };
    let exitData: EXIT= {
      entity_type: '',
      entity_code: this.communityEntityCode ?? 0,
      current_screen_name: '',
      start_time: 0,
      end_time: 0
    };
    entryData.entity_type = PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY;
    entryData.entity_code = this.communityEntityCode ?? 0;
    entryData.source = this.internalSource;
    exitData.entity_type = PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY;
    exitData.entity_code = this.communityEntityCode ?? 0;
    exitData.start_time = this.startTime;
    exitData.end_time = new Date().getTime();
    if (previousValue != null && previousValue != undefined) {
      if (previousValue === NUMBERS.ZERO) {
        exitData.current_screen_name = SCREEN_NAME.COMMUNITY_ADD_MEMBERS
      } else if (previousValue === NUMBERS.ONE) {
        exitData.current_screen_name = SCREEN_NAME.COMMUNITY_EXISTING_MEMBER;
      } else if (previousValue === NUMBERS.TWO) {
        exitData.current_screen_name = SCREEN_NAME.COMMUNITY_REMOVE_MEMBER;
      } else if (previousValue === NUMBERS.THREE) {
        if (reviewState === NUMBERS.TWO) {
          exitData.current_screen_name = SCREEN_NAME.REVIEW_REMOVAL_MEMEBRS
        } else if (reviewState === NUMBERS.ONE) {
          exitData.current_screen_name = SCREEN_NAME.COMMUNITY_MEMBER_REVIEW;
        }
      }
      this.analyticSdk.analyticService.EXIT(exitData);
    }
    if (currentValue!= undefined && currentValue != null) {
      this.startTime = new Date().getTime();
      entryData.start_time = new Date().getTime();
      if (currentValue === NUMBERS.ZERO) {
        entryData.current_screen_name = SCREEN_NAME.COMMUNITY_ADD_MEMBERS
      } else if (currentValue === NUMBERS.ONE) {
        entryData.current_screen_name = SCREEN_NAME.COMMUNITY_EXISTING_MEMBER;
      } else if (currentValue === NUMBERS.TWO) {
        entryData.current_screen_name = SCREEN_NAME.COMMUNITY_REMOVE_MEMBER;
      } else if (currentValue === NUMBERS.THREE) {
        if (reviewState === NUMBERS.TWO) {
          entryData.current_screen_name = SCREEN_NAME.REVIEW_REMOVAL_MEMEBRS
        } else if (reviewState === NUMBERS.ONE) {
          entryData.current_screen_name = SCREEN_NAME.COMMUNITY_MEMBER_REVIEW;
        }
      }
      this.internalSource = entryData.current_screen_name;
      this.analyticSdk.analyticService.ENTRY(entryData);
    }
  }
  /**
   * On Changes
   */
  ngOnChanges(changes : SimpleChanges): void {
    this.showExistingUsersFlag = this.showExistingUserFlag;
    if(changes.clicked){
      this.handleMemberListChange(changes.clicked.previousValue,changes.clicked.currentValue, this.reviewState )
      this.resetSearchBox();
    }
  }


  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    this.handleMemberListChange(this.clicked, null, this.reviewState);
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.memberList = [];
    this.createCommunityService.memberList = [];
  }

  /**
   *  For getting existing member list
   */
  getMembersList(): void {
    if (this.communityId && this.callingFrom !== SCREEN_NAME.COMMUNITY_DETAILS) {
      if (this.offset !== NUMBERS.ZERO) {
        this.apiInProcess = true;
        this.subscriptions.add(this.getApiAervice.getCommunityMembers('', this.communityId, this.offset, '').subscribe((res: CommunityMembersResponse) => {
          if (res.status === NUMBERS.ONE) {
            this.apiInProcess = false;
            this.memberList = this.memberList.concat(res.data.members);
            this.offset = res.data.offset;
          } else {
            this.fcs.errorHandeler(res);
          }
        }, (err) => this.fcs.errorHandeler(err)));
      }
    }
  }
  /**
   * On the time of close existing member.
   */
  closeExistingMember(): void {
    this.showMemberModal = false;
    this.existingMembersOffset = NUMBERS.ONE;
    this.memberList = [];
  }

  /**
   * Enable button
   */
  addAgain(): void {
    this.showAddagain = NUMBERS.ONE;
  }

  /**
   * Disable button
   */
  removeEnable(): void {
    this.showAddagain = NUMBERS.ZERO;
  }


  /**
   * Limit pop up disable
   */
  maxPopUpDisable(): void {
    this.showMaxPopUp = false;
  }

}



